<template>
  <div class="folder radius">
    <div class="column caption">
      <p>Вставка альбома</p>
    </div>
    <div class="column">
      <div class="content">
        <v-alert :value="true" color="info" icon="info" outline>
          Выберите из списка ранее созданный альбом и вставте вручную или с помощью кнопки "Вставить альбом в редактор" (вставка произойдет в последнее место редактирования).
        </v-alert>
        <div class="list">
          <p>Альбомы</p>
          <div class="dropdown" v-on-click-outside="hideDropDown">
            <input id="dd-edit-albums" type="checkbox" v-model="showList">
            <label for="dd-edit-albums">
              <span class="dd-darken">{{selectedItem.title || 'Выберите альбом'}}</span>
              <span class="triangle"></span>
            </label>
            <ul>
              <li v-for="item in items"
                  @click="onItem(item)">{{item.title}}
              </li>
            </ul>
          </div>
        </div>
        <div class="list">
          <p>Код для вставки альбома</p>
          <input type="text" v-model="codeAlbum" disabled>
        </div>
        <div class="buttons">
          <button class="save" :class="{disabled: !codeAlbum}" @click="insertAlbum">Вставить альбом в редактор</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mixin as onClickOutside} from 'vue-on-click-outside'
  import {mapMutations, mapActions, mapState} from 'vuex'
  export default {
    mixins: [onClickOutside],
    name: "InsertAlbum",
    data() {
      return {
        showList: false,
        items: [],
        codeAlbum: '',
        selectedItem: ''
      }
    },
    computed: {
      ...mapState([
        'parentId',
        'apiUrls'
      ])
    },
    methods: {
      hideDropDown() {
        this.showList = false
      },
      getItems() {
        this.$http.get(
          `${this.apiUrls.content}?search=parent_id:${this.parentId.albums};is_active:1&searchJoin=and&orderBy=created_at&sortedBy=desc`
        ).then(response => {
          if (response.data.data) {
            this.items = response.data.data
          }
        }).catch(error => {
          this.$store.dispatch('notification/errorAxios', error.response.status, {root: true})
        })
      },
      insertAlbum() {
        if (this.codeAlbum) {
          this.$emit('insertAlbum', this.codeAlbum)
        }
      },
      onItem(item) {
        this.hideDropDown()
        this.selectedItem = item
        this.codeAlbum = `%%album-${item.id}%%`
      }
    },
    created() {
      this.getItems()
    }
  }
</script>

<style lang="scss" scoped>
  .v-alert {
    margin-bottom: 20px;
    @media screen and (max-width: 1200px) {
      margin-bottom: 10px;
    }
  }
  button {
    width: initial !important;
    padding: 10px 20px !important;
    &.disabled {
      opacity: 0.6;
      pointer-events: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/edit-form/InsertAlbum.vue